module.exports = __webpack_public_path__ + "static/media/pulve.8cd6968d.mp4";